import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-screen overflow-hidden flex flex-col" }
const _hoisted_2 = { class: "lg:grid lg:grid-cols-3 gap-[25px] flex-grow h-full overflow-hidden chat-container" }

import { ref, onMounted, onUnmounted } from "vue";
import Sidebar from "@/components/Apps/Chat/Sidebar.vue";
import ChatPanel from "@/components/Apps/Chat/index.vue";
import AddEventModal from "@/components/Apps/Calendar/AddEventModal.vue";
import EditEventModal from "@/components/Apps/Calendar/EditEventModal.vue";
import { useI18n } from "vue-i18n";
import enTranslations from "@/i18n/locales/en.json";
import heTranslations from "@/i18n/locales/he.json";
import arTranslations from "@/i18n/locales/ar.json";

// Type definition for translation objects
type TranslationObject = {
  [key: string]: string | TranslationObject;
};

// i18n setup
interface ChatData {
  id: string | number;
  name: string;
  image: string;
  lastMessage?: string;
  lastTime?: string;
  unread?: number;
  [key: string]: any; // לשדות נוספים שיכולים להיות
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ChatPage',
  setup(__props) {

const { locale } = useI18n();

// Translation files
const translationFiles = {
  en: enTranslations,
  he: heTranslations,
  ar: arTranslations
};

// Direct translation function that bypasses vue-i18n
const directT = (key: string): string => {
  const parts = key.split('.');
  let result: TranslationObject = translationFiles[locale.value as keyof typeof translationFiles];
  
  for (const part of parts) {
    if (!result || !(part in result)) {
      console.warn(`Missing translation key: ${key} in ${locale.value} locale`);
      // Fallback to English if translation not found
      let enResult: TranslationObject = translationFiles.en;
      for (const fallbackPart of parts) {
        if (!enResult || !(fallbackPart in enResult)) return key;
        enResult = enResult[fallbackPart as keyof typeof enResult] as TranslationObject;
      }
      return typeof enResult === 'string' ? enResult : key;
    }
    result = result[part as keyof typeof result] as TranslationObject;
  }
  return typeof result === 'string' ? result : key;
};

// הגדרת ממשק לצ'אט
const editEventModalRef = ref<any>(null);
const selectedChat = ref<ChatData | null>(null);
const isMobile = ref(false);

// בדיקה אם המכשיר הוא מובייל
const checkIfMobile = (): void => {
  isMobile.value = window.innerWidth < 1024; // lg breakpoint in Tailwind
};

// בחירת צ'אט ומעבר לתצוגת צ'אט במובייל
const selectChat = (chat: ChatData): void => {
  selectedChat.value = chat;
};

// חזרה לרשימת הצ'אטים
const backToList = (): void => {
  if (isMobile.value) {
    selectedChat.value = null;
  }
};

// עקיבה אחר שינויי גודל המסך
onMounted(() => {
  checkIfMobile();
  window.addEventListener('resize', checkIfMobile);
});

onUnmounted(() => {
  window.removeEventListener('resize', checkIfMobile);
});

function openEditEventModal(event: any): void {
  if (editEventModalRef.value) {
    editEventModalRef.value.openModal(event);
  }
}

// Handle the update-bot-status event
function handleBotStatusUpdate(data: { threadId: string | number, botstatus: boolean }): void {
  console.log('Updating bot status in parent:', data);
  if (selectedChat.value && selectedChat.value.id === data.threadId) {
    // Create a new object to avoid mutating the original
    const updatedChat = Object.assign({}, selectedChat.value);
    updatedChat.botstatus = data.botstatus;
    selectedChat.value = updatedChat;
    console.log('Bot status updated in parent component:', selectedChat.value.botstatus);
  }
}

// Handle the chats-loaded event - auto-select first chat on desktop
function handleChatsLoaded(chats: ChatData[]): void {
  console.log('Chats loaded in parent component', { count: chats.length });
  
  // Auto-select the first chat only on desktop (not mobile)
  if (!isMobile.value && chats.length > 0 && !selectedChat.value) {
    console.log('Auto-selecting first chat on desktop');
    selectChat(chats[0]);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(["lg:col-span-1 h-full overflow-hidden chat-sidebar", { 'hidden': selectedChat.value && isMobile.value }])
        }, [
          _createVNode(Sidebar, {
            onChatSelected: selectChat,
            onChatsLoaded: handleChatsLoaded
          })
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["lg:col-span-2 h-full overflow-hidden chat-panel", { 'hidden': !selectedChat.value && isMobile.value }])
        }, [
          _createVNode(ChatPanel, {
            "selected-chat": selectedChat.value,
            onBackToList: backToList,
            onUpdateBotStatus: handleBotStatusUpdate
          }, null, 8, ["selected-chat"])
        ], 2)
      ])
    ]),
    _createVNode(AddEventModal),
    _createVNode(EditEventModal, {
      ref_key: "editEventModalRef",
      ref: editEventModalRef
    }, null, 512)
  ], 64))
}
}

})